/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Title_AwardsInputs */

const en_resume_title_awards = /** @type {(inputs: Resume_Title_AwardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Awards`)
};

const ar_resume_title_awards = /** @type {(inputs: Resume_Title_AwardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الجوائز`)
};

const bn_resume_title_awards = /** @type {(inputs: Resume_Title_AwardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পুরস্কার`)
};

const de_resume_title_awards = /** @type {(inputs: Resume_Title_AwardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auszeichnungen`)
};

const es_resume_title_awards = /** @type {(inputs: Resume_Title_AwardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premios`)
};

const fr_resume_title_awards = /** @type {(inputs: Resume_Title_AwardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Récompenses`)
};

const pt_resume_title_awards = /** @type {(inputs: Resume_Title_AwardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prêmios`)
};

const zh_resume_title_awards = /** @type {(inputs: Resume_Title_AwardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`奖项`)
};

const tr_resume_title_awards = /** @type {(inputs: Resume_Title_AwardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ödüller`)
};

const ru_resume_title_awards = /** @type {(inputs: Resume_Title_AwardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Награды`)
};

const pl_resume_title_awards = /** @type {(inputs: Resume_Title_AwardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nagrody`)
};

/**
* | output |
* | --- |
* | "Awards" |
*
* @param {Resume_Title_AwardsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const resume_title_awards = /** @type {((inputs?: Resume_Title_AwardsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Title_AwardsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_resume_title_awards(inputs)
	if (locale === "bn") return bn_resume_title_awards(inputs)
	if (locale === "de") return de_resume_title_awards(inputs)
	if (locale === "es") return es_resume_title_awards(inputs)
	if (locale === "fr") return fr_resume_title_awards(inputs)
	if (locale === "pt") return pt_resume_title_awards(inputs)
	if (locale === "zh") return zh_resume_title_awards(inputs)
	if (locale === "tr") return tr_resume_title_awards(inputs)
	if (locale === "ru") return ru_resume_title_awards(inputs)
	if (locale === "pl") return pl_resume_title_awards(inputs)
	return en_resume_title_awards(inputs)
});